<template>
  <v-container fluid class="township-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-township`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-home-city</v-icon>
            Town
          </v-tab>
          <v-tab-item
            :value="'tab-township'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Town</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'townshipcode')"
                        v-bind:value="initvalue.townshipcode"
                        placeholder="Town Code"
                        persistent-hint
                        single-line hint="Enter the township code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'townshipname')"
                        v-bind:value="initvalue.townshipname"
                        placeholder="Town Name"
                        persistent-hint
                        single-line hint="Enter the township name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'townshipnameinfo')"
                        v-bind:value="initvalue.townshipnameinfo"
                        placeholder="Info Text"
                        persistent-hint
                        single-line hint="Enter the info text">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=townshiptype
                        :value="initvalue.townshiptype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'townshiptype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the township type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                        :value="initvalue.regionid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regionid')"
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'townshipstatus')"
                          v-bind:label="initvalue.townshipstatus"
                          v-model="initvalue.townshipstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/township/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTown()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      township: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      townshiptype: ['District', 'Town', 'Township'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['updateTownshipRequest','getTownshipsRequest']),
    editTown() {
      this.township._id = this.initvalue._id;
      console.log(this.township);
      this.updateTownshipRequest(this.township);
      this.getTownshipsRequest();
      router.push('/township/list');
    },
    updateChangedValue(value, field){
      this.township[field] = value;
    },
  },
  computed: {
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['isReceiving']),
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'TownList' });
    if(this.regions.length==0) this.getRegionsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
